module.exports = __webpack_public_path__ + "img/icecream.be5030ca.webp";